import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;
type OwnerReportingRuntime = Pick<BusinessRuntime, 'smtReporting'>;

export interface OwnerRuntimeHost {
  readonly runtime: OwnerReportingRuntime;
  readonly actorId: string;
  readonly businessDate: string;
  readonly now?: () => string;
}

type OwnerGlobal = typeof globalThis & {__MOREFUNOS_OWNER_REPORTING__?: OwnerRuntimeHost};

export function resolveOwnerRuntimeHost(): OwnerRuntimeHost | null {
  const candidate = (globalThis as OwnerGlobal).__MOREFUNOS_OWNER_REPORTING__;
  if (!candidate?.runtime?.smtReporting || !candidate.actorId?.trim() || !candidate.businessDate?.trim()) return null;
  return candidate;
}
